import React, { useState } from 'react';
import './TicketSettingsPage.css';
import OwnerSidebar from '../../../Components/OwnerSidebar/OwnerSidebar';
import { Calendar, Clock, Trash2, Edit2, CalendarDays } from 'lucide-react';

export default function TicketSettingsPage() {
  const [tickets, setTickets] = useState([
    {
      id: 1,
      type: 'specific', // 'specific' 또는 'weekly'
      date: '2024-03-20',
      dayOfWeek: null,
      startTime: '23:00',
      endTime: '04:00',
      price: 15000,
      quantity: 100,
      sold: 50,
      status: '판매중'
    },
    {
      id: 2,
      type: 'weekly',
      date: null,
      dayOfWeek: 'fri',
      startTime: '23:00',
      endTime: '04:00',
      price: 20000,
      quantity: 100,
      sold: 100,
      status: '매진'
    }
  ]);

  const [ticketType, setTicketType] = useState('specific'); // 'specific' 또는 'weekly'
  const [newTicket, setNewTicket] = useState({
    type: 'specific',
    date: '',
    dayOfWeek: '',
    startTime: '23:00',
    endTime: '04:00',
    price: '',
    quantity: '',
    status: '판매중'
  });

  const handleCreateTicket = (e) => {
    e.preventDefault();
    
    if (parseInt(newTicket.price) < 0) {
      alert('가격은 0원 이상이어야 합니다.');
      return;
    }

    const ticket = {
      id: tickets.length + 1,
      ...newTicket,
      sold: 0
    };
    setTickets([...tickets, ticket]);
    setNewTicket({
      type: ticketType,
      date: '',
      dayOfWeek: '',
      startTime: '23:00',
      endTime: '04:00',
      price: '',
      quantity: '',
      status: '판매중'
    });
  };

  const handleDeleteTicket = (id) => {
    setTickets(tickets.filter(ticket => ticket.id !== id));
  };

  const weekDays = [
    { value: 'mon', label: '월요일' },
    { value: 'tue', label: '화요일' },
    { value: 'wed', label: '수요일' },
    { value: 'thu', label: '목요일' },
    { value: 'fri', label: '금요일' },
    { value: 'sat', label: '토요일' },
    { value: 'sun', label: '일요일' }
  ];

  return (
    <div className="ticket-settings-page">
      <OwnerSidebar />
      <main className="ticket-settings-main">
        <div className="ticket-settings-header">
          <h1>티켓 관리</h1>
        </div>

        <div className="ticket-management-container">
          <section className="ticket-creation-section">
            <div className="ticket-creation-header">
              <h2>티켓 생성</h2>
              <div className="ticket-creation-toggle">
                <button
                  className={`ticket-creation-toggle-button ${ticketType === 'specific' ? 'active' : ''}`}
                  onClick={() => {
                    setTicketType('specific');
                    setNewTicket({...newTicket, type: 'specific', dayOfWeek: ''});
                  }}
                >
                  <Calendar className="ticket-creation-icon" />
                  특정 날짜
                </button>
                <button
                  className={`ticket-creation-toggle-button ${ticketType === 'weekly' ? 'active' : ''}`}
                  onClick={() => {
                    setTicketType('weekly');
                    setNewTicket({...newTicket, type: 'weekly', date: ''});
                  }}
                >
                  <CalendarDays className="ticket-creation-icon" />
                  요일별
                </button>
              </div>
            </div>

            <form onSubmit={handleCreateTicket} className="ticket-creation-form">
              {ticketType === 'specific' ? (
                <div className="form-group">
                  <label>
                    <Calendar className="icon" />
                    날짜
                  </label>
                  <input
                    type="date"
                    value={newTicket.date}
                    onChange={(e) => setNewTicket({...newTicket, date: e.target.value})}
                    required
                    className="form-input"
                  />
                </div>
              ) : (
                <div className="form-group">
                  <label>
                    <CalendarDays className="icon" />
                    요일 선택
                  </label>
                  <div className="weekday-selector">
                    {weekDays.map(day => (
                      <button
                        key={day.value}
                        type="button"
                        className={`weekday-button ${newTicket.dayOfWeek === day.value ? 'active' : ''}`}
                        onClick={() => setNewTicket({...newTicket, dayOfWeek: day.value})}
                      >
                        {day.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div className="form-group">
                <label>
                  <Clock className="icon" />
                  입장 시간대
                </label>
                <div className="time-range-input">
                  <div className="time-input-group">
                    <span className="time-label">시작</span>
                    <input
                      type="time"
                      value={newTicket.startTime}
                      onChange={(e) => setNewTicket({...newTicket, startTime: e.target.value})}
                      required
                      className="form-input"
                    />
                  </div>
                  <span className="time-separator">~</span>
                  <div className="time-input-group">
                    <span className="time-label">종료</span>
                    <input
                      type="time"
                      value={newTicket.endTime}
                      onChange={(e) => setNewTicket({...newTicket, endTime: e.target.value})}
                      required
                      className="form-input"
                    />
                  </div>
                </div>
                <p className="time-note">※ 다음날 새벽까지 운영 시 종료 시간을 04:00와 같이 설정하세요</p>
              </div>

              <div className="form-group">
                <label>가격</label>
                <div className="price-input">
                  <input
                    type="number"
                    value={newTicket.price}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (value >= 0 || e.target.value === '') {
                        setNewTicket({...newTicket, price: e.target.value});
                      }
                    }}
                    placeholder="가격을 입력하세요"
                    min="0"
                    required
                    className="form-input"
                  />
                  <span className="unit">원</span>
                </div>
              </div>

              <div className="form-group">
                <label>최대 수량</label>
                <div className="quantity-input">
                  <input
                    type="number"
                    value={newTicket.quantity}
                    onChange={(e) => setNewTicket({...newTicket, quantity: e.target.value})}
                    placeholder="수량을 입력하세요"
                    min="1"
                    required
                    className="form-input"
                  />
                  <span className="unit">매</span>
                </div>
              </div>

              <button type="submit" className="create-button">
                티켓 생성
              </button>
            </form>
          </section>

          <section className="ticket-list-section">
            <h2>티켓 목록</h2>
            <div className="ticket-list">
              {tickets.map(ticket => (
                <div key={ticket.id} className="ticket-item">
                  <div className="ticket-info">
                    <div className="ticket-date">
                      {ticket.type === 'specific' ? (
                        <>
                          <Calendar className="icon" />
                          {ticket.date}
                        </>
                      ) : (
                        <>
                          <CalendarDays className="icon" />
                          {weekDays.find(day => day.value === ticket.dayOfWeek)?.label}
                        </>
                      )}
                    </div>
                    <div className="ticket-time">
                      <Clock className="icon" />
                      {ticket.startTime} ~ {ticket.endTime}
                    </div>
                    <div className="ticket-price">
                      {ticket.price.toLocaleString()}원
                    </div>
                    <div className="ticket-quantity">
                      {ticket.sold}/{ticket.quantity}매
                    </div>
                    <div className={`ticket-status ${ticket.status === '매진' ? 'sold-out' : ''}`}>
                      {ticket.status}
                    </div>
                  </div>
                  <div className="ticket-actions">
                    <button className="edit-button">
                      <Edit2 size={16} />
                    </button>
                    <button 
                      className="delete-button"
                      onClick={() => handleDeleteTicket(ticket.id)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
} 